export const news = [
    {
        news_id: "004",
        year: "2023",
        month: "08",
        date: "01",
        title: "2023產學跨域師資培育講座 開放報名囉！歡迎各位老師與學生一同參與！",
        content:
            "ITSA-C類 開源系統軟體與軟韌體人才深化團隊將舉辦產學跨域師資培育講座，針對產業相關研究主題及趨勢發展進行分享與交流，敬邀各位教授及學生一同參與此次講座。\n\
            報名時間：即日起至2023/08/15 中午12:00止\n\
            活動日期：2023年8月17日(四)\n\
            活動地點：國立臺北科技大學 先鋒大樓402室\n\
            活動議程＆報名鏈結：\n\
            https://www.surveycake.com/s/QQql8\
        ",
        image: [
            {
                image00: "../images/2023actPoster.jpg",
                image01: "../images/2023actSchedule.jpg",
            }
        ],
        audio: [
            {
                audio00: "../audio/",
            }
        ],
        video: [
            {
                video00: "../video/",
            }
        ],
    },
    {
        news_id: "003",
        year: "2023",
        month: "06",
        date: "05",
        title: "2023年 ITSA全國大專校院程式設計極客挑戰賽開始報名囉!",
        content:
            "歡迎大家踴躍參與~\n\
            報名時間：即日起至2023/09/15 17:00止\n\
            https://www.itsa.org.tw/itsacontest/2023/index.php\n\
            第一名：獎金新臺幣伍萬元整、指導教師與每位隊員獎狀乙紙。\n\
            第二名：獎金新臺幣參萬元整、指導教師與每位隊員獎狀乙紙。\n\
            第三名：獎金新臺幣壹萬元整、指導教師與每位隊員獎狀乙紙。\n\
            佳　作：每隊獎金新臺幣伍仟元整、指導教師與每位隊員獎狀乙紙。\
        ",
        image: [
            {
                image00: "../images/ITSA極客挑戰賽1.jpg",
                image01: "../images/ITSA極客挑戰賽2.jpg",
            }
        ],
        audio: [
            {
                audio00: "../audio/",
            }
        ],
        video: [
            {
                video00: "../video/",
            }
        ],
    },
    {
        news_id: "002",
        year: "2023",
        month: "06",
        date: "01",
        title: "2023全國大專校院智慧創新暨跨域整合創作競賽開始報名囉 !",
        content:
            "2023全國大專校院智慧創新暨跨域整合創作競賽開始報名囉 ! \n\
            歡迎大家踴躍參與~\n\
            報名時間 2023/05/01 至 2023/07/07 23:59止。\n\
            https://niicc.cilab.csie.ncu.edu.tw/\n\
            第一名各 1 隊，每隊獎金新臺幣 10 萬元、指導教師與每位隊員獎狀 1 紙。\n\
            第二名各 2 隊，每隊獎金新臺幣 5 萬元、指導教師與每位隊員獎狀 1 紙。\n\
            第三名各 3 隊，每隊獎金新臺幣 2 萬元、指導教師與每位隊員獎狀 1 紙。\n\
            佳作各 4 隊，每隊獎金新臺幣 5 千元、指導教師與每位隊員獎狀 1 紙。\n\
            跨域整合特別獎各 1 隊，每隊獎金新臺幣 2 萬元、指導教師與每位隊員獎狀 1 紙。\n\
            競賽主題為智慧創新暨跨域整合創作，包含下列四項主題：\n\
            1.物聯網與金融科技組：物聯網、雲端運算、邊緣運算、網路應用與服務、光通訊技術與系統、電商與金融科技應用、區塊鏈、巨量資料應用、NFT。\n\
            2.智慧機器組：包含智慧型機器人、智慧監控、智慧型控制、工業 4.0、電腦視覺、嵌入式系統、感測技術、量測儀器設計。\n\
            3.數位永續科技組：包含智慧生活、智慧城市、智慧綠能、健康照護、醫療照護、社會關懷、人工智慧、災害防治與監控、ESG。\n\
            4.體感互動科技組：包含 AR/VR/MR、體感互動、互動多媒體、多媒體與數位內容、人機介面與互動、遊戲、電子書、穿戴式裝置、元宇宙。\
        ",
        image: [
            {
                image00: "../images/ITSA_cross_field.jpg",
            }
        ],
        audio: [
            {
                audio00: "../audio/",
            }
        ],
        video: [
            {
                video00: "../video/",
            }
        ],
    },
    {
        news_id: "001",
        year: "2023",
        month: "06",
        date: "01",
        title: "開源系統軟體與軟韌體人才深化 網頁啟用!",
        content:
            "開源系統軟體與軟韌體人才深網站開始啟用囉!除了公告最新資訊外，還提供相關課程教材，歡迎踴躍下載。\n\
        https://itsa-c.web.app/map\n\
        同時Facebook以及Instagram粉絲頁也同步上線囉!\n\
        https://reurl.cc/WGA33D\n\
        https://www.instagram.com/ntutitsa/\n\
        歡迎大家追蹤我們!\n\
        除了提供相關計畫或是競賽資訊外，還會不時分享相關技術貼文!趕緊追蹤起來喔!\
        ",
        image: [
            {
                image00: "../images/ITSA開源系統軟體與軟韌體人才深化.jpg",
            }
        ],
        audio: [
            {
                audio00: "../audio/",
            }
        ],
        video: [
            {
                video00: "../video/",
            }
        ],
    },
]